import { Injectable } from '@angular/core';

import { select, Store, Action } from '@ngrx/store';

import * as fromSubscriptions from './subscriptions.reducer';
import * as SubscriptionsSelectors from './subscriptions.selectors';
import * as SubscriptionsActions from './subscriptions.actions';
import {
  CreateSubscriptionDTO,
  LoadType,
  UpdateSubscriptionDTO
} from '@care-portals/api-interfaces';

@Injectable()
export class SubscriptionsFacade {
  state$ = this.store.pipe(
    select(SubscriptionsSelectors.getSubscriptionsState)
  );
  subscriptions$ = this.store.pipe(
    select(SubscriptionsSelectors.getSubscriptionsEntities)
  );
  allSubscriptions$ = this.store.pipe(
    select(SubscriptionsSelectors.getAllSubscriptions)
  );
  loading$ = this.store.pipe(
    select(SubscriptionsSelectors.getSubscriptionsLoading)
  );
  discountModal$ = this.store.pipe(
    select(SubscriptionsSelectors.getDiscountModal)
  );
  selectedId$ = this.store.pipe(
    select(SubscriptionsSelectors.getSelectedSubscriptionId)
  );
  selected$ = this.store.pipe(select(SubscriptionsSelectors.getSelected));
  selectedSubscription$ = this.store.pipe(
    select(SubscriptionsSelectors.selectCurrentSubscription)
  );
  lastFetched$ = this.store.pipe(
    select(SubscriptionsSelectors.getSubscriptionsLastFetch)
  );
  hasMore$ = this.store.pipe(select(SubscriptionsSelectors.hasMore));
  activeDigitalSubscriptions$ = this.store.pipe(
    select(SubscriptionsSelectors.getActiveDigitalSubscriptions)
  );
  activePhysicalSubscriptions$ = this.store.pipe(
    select(SubscriptionsSelectors.getActivePhysicalSubscriptions)
  );

  constructor(
    private store: Store<fromSubscriptions.SubscriptionsPartialState>
  ) { }

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  getSubscriptions(loadType: LoadType, filters: any, reset: boolean = false, supressNotification: boolean = false) {
    // ISubscriptionsListParams

    if (reset) {
      this.dispatch(SubscriptionsActions.resetSubscriptions());
    }
    this.dispatch(
      SubscriptionsActions.getSubscriptions({ loadType, params: filters, supressNotification })
    );
  }

  clearSubscription() {
    this.dispatch(SubscriptionsActions.clearSubscription());
  }

  getSubscription(subscriptionId: string) {
    this.dispatch(SubscriptionsActions.getSubscription({ subscriptionId }));
  }

  openSubscriptionDetailsDrawer(subscriptionId: string, onClose?: () => void) {
    this.dispatch(
      SubscriptionsActions.openSubscriptionDetailsDrawer({ subscriptionId, onClose })
    );
  }

  closeSubscriptionDetailsDrawer() {
    this.dispatch(SubscriptionsActions.closeSubscriptionDetailsDrawer());
  }

  cancelSubscription(id: string) {
    this.dispatch(SubscriptionsActions.cancelSubscription({ id }));
  }

  pauseSubscription(id: string) {
    this.dispatch(
      SubscriptionsActions.updateSubscription({
        id,
        updates: { status: 'paused' }
      })
    );
  }

  resumeSubscription(id: string) {
    this.dispatch(
      SubscriptionsActions.updateSubscription({
        id,
        updates: { status: 'active' }
      })
    );
  }

  changeCurrentCycle(id: string, currentCycle: number) {
    this.dispatch(
      SubscriptionsActions.updateSubscription({
        id,
        updates: { currentCycle }
      })
    );
  }

  changeNextCycleDate(id: string, nextCycleDate: Date) {
    this.dispatch(
      SubscriptionsActions.updateSubscription({
        id,
        updates: { nextCycleDate }
      })
    );
  }

  updateSubscription(id: string, updates: UpdateSubscriptionDTO) {
    this.dispatch(SubscriptionsActions.updateSubscription({ id, updates }));
  }

  createSubscription(payload: Partial<CreateSubscriptionDTO>) {
    this.dispatch(SubscriptionsActions.createSubscription({ payload }));
  }

  // applyDiscount(req: ApplySubscriptionsDiscountDTO) {
  //     this.dispatch(SubscriptionsActions.applyDiscountForSubscriptions({ req }));
  // }

  //   openDiscountModal(subscriptions: ISubscriptions) {
  //     this.dispatch(SubscriptionsActions.openDiscountModal({ subscriptions }));
  //   }

  closeDiscountModal() {
    this.dispatch(SubscriptionsActions.closeDiscountModal());
  }

  exportSubscriptions(dateRange: [Date, Date]) {
    this.dispatch(SubscriptionsActions.exportSubscriptions({ dateRange }));
  }
}
